<!-- src/layouts/MainLayout.vue -->
<template>
  <!-- Footer Start -->

  <footer
    :class="[{ homeFooter: isHomePage }, 'footer-section', 'pb-5', 'pt-15']"
  >
    <div class="container">
      <div class="row text-white">
        <!-- First Column: Logo and Supported by -->
        <div class="col-lg-4 text-center text-lg-start">
          <img
            src="/assets/img/Duhallow-logo-small.png"
            alt="Duhallow"
            class="mb-3 footer-logo"
          />
        </div>

        <!-- Second Column: Useful Links -->
        <div class="col-lg-4 text-align-right">
          <h3 class="footer-title">USEFUL LINKS:</h3>
          <ul class="list-unstyled">
            <li>
              <a
                href="#"
                class="footer-link"
                @click.prevent="showEmergencyModal = true"
              >
                Emergency Services CALL 112
              </a>
            </li>
            <!--<li><a href="#" class="footer-link">Report an issue</a></li>-->
            <li>
              <a
                href="https://www.met.ie/weather-forecast/newmarket-cork"
                class="footer-link"
                target="_blank"
                >Weather</a
              >
            </li>
            <li>
              <a href="https://www.transportforireland.ie/" class="footer-link"
                >Transport</a
              >
            </li>
          </ul>
        </div>
        <!-- Emergency Modal -->
        <EmergencyModal
          v-if="showEmergencyModal"
          :isVisible="showEmergencyModal"
          @close="showEmergencyModal = false"
        />

        <!-- Third Column: Contact Us -->
        <div class="col-lg-4 text-align-right">
          <h3 class="footer-title">CONTACT US:</h3>
          <ul class="contact-us list-unstyled">
            <li>IRD Duhallow,</li>
            <li>James O'Keeffe Institute</li>
            <li>Newmarket</li>
            <li>Co. Cork</li>
            <li class="mt-3">Telephone: 029-60633</li>
          </ul>
          <!--<div>
                        <img src="//assets/img/phone.svg" alt="Phone">
                        <a href="tel:+35340420100" class="contact-link mx-2">+353 404 20100</a>
                    </div>-->
          <div class="mt-2">
            <img src="/assets/img/envelope.svg" alt="Email" />
            <a href="mailto:duhallow@irdduhallow.com" class="contact-link mx-2"
              >E-mail: duhallow@irdduhallow.com</a
            >
          </div>

          <div class="social-icons mt-4">
            <!-- Facebook -->

            <a href="https://www.facebook.com/irdduhallow/" target="_blank">
              <img
                src="/assets/img/social-yellow-facebook.svg"
                alt="Facebook"
                class="social-icon"
              />
            </a>

            <!-- Instagram -->
            <a
              href="https://www.instagram.com/irdduhallowclg/"
              target="_blank"
            >
              <img
                src="/assets/img/social-yellow-instagram.svg"
                alt="Instagram"
                class="social-icon"
              />
            </a>

            <!-- LinkedIn -->
            <a
              href="https://www.linkedin.com/company/ird-duhallow/?originalSubdomain=ie"
              target="_blank"
            >
              <img
                src="/assets/img/social-yellow-linkedin.svg"
                alt="LinkedIn"
                class="social-icon"
              />
            </a>

            <!-- Youtube -->
            <a
              v-if="socialLinks.Youtube"
              :href="socialLinks.Youtube"
              target="_blank"
            >
              <img
                src="/assets/img/social-yellow-youtube.svg"
                alt="YouTube"
                class="social-icon"
              />
            </a>

            <a @click.prevent="sharePage" target="_blank">
              <img
                src="/assets/img/share-alt-yellow.svg"
                alt="Share"
                class="social-icon social-footer"
              />
            </a>

            <!--
            <a href="#" target="_blank"
              ><img
                src="/assets/img/social-green-tiktok.svg"
                alt="TikTok"
                class="social-icon"
            /></a>
            -->

            <!-- Twitter 
            <a
              v-if="socialLinks.Twitter"
              :href="socialLinks.Twitter"
              target="_blank"
            >
              <img
                src="/assets/img/social-green-x.svg"
                alt="X"
                class="social-icon"
              />
            </a>-->
          </div>
        </div>
      </div>

      <!-- Full-width supporters bar spanning the bottom of the footer -->
      <div class="supported-by-bar">
        <p class="support-text text-center">Proudly Supported by:</p>
        <!-- White panel so the transparent partner logos stay visible -->
        <div class="partner-logos">
          <img src="/assets/img/partners/1_LEADER.png" alt="LEADER" />
          <img
            src="/assets/img/partners/2_IRDDuhallow.png"
            alt="IRD Duhallow"
          />
          <img
            src="/assets/img/partners/3_govt-2040.png"
            alt="Government of Ireland – Project Ireland 2040"
          />
          <img src="/assets/img/partners/4_EU.png" alt="European Union" />
          <img src="/assets/img/partners/5_RRO.png" alt="RRO" />
          <img
            src="/assets/img/partners/6_LeaveNoTrace.png"
            alt="Leave No Trace"
          />
        </div>
      </div>

      <div class="developed-by">
        Developed by Evolve Technologies <span>|</span> All rights reserved.
      </div>
    </div>
  </footer>
  <button
    type="button"
    class="btn btn-danger btn-floating btn-lg"
    id="btn-back-to-top"
    @click="backToTop"
  >
    ↑
  </button>
</template>

<script>
import db from "@/db";
import EmergencyModal from "./EmergencyModal.vue";

export default {
  name: "Header",
  components: {
    EmergencyModal,
  },
  created() {
    // Fetch the tenantId from local storage when the component is created
    this.tenantId = localStorage.getItem("tenantId");
    this.loadSocialLinks();
  },
  data() {
    return {
      showEmergencyModal: false,
      tenantId: "", // Initial state
      header: {},
      version: null,
      socialLinks: {},
      canShare: false,
    };
  },
  computed: {
    titleMain() {
      if (this.header && this.header.Title) {
        // Split the title into words
        const words = this.header.Title.split(" ");
        // If there is more than one word, return all except the last one
        return words.length > 1
          ? words.slice(0, -1).join(" ")
          : this.header.Title;
      }
      return ""; // Return an empty string if header.Title is not defined
    },
    titleLast() {
      if (this.header && this.header.Title) {
        // Split the title into words
        const words = this.header.Title.split(" ");
        // Return the last word if there is more than one
        return words.length > 1 ? words[words.length - 1] : "";
      }
      return ""; // Return an empty string if header.Title is not defined
    },
    isHomePage() {
      return this.$route.name === "home"; // Ensure 'home' is the name of your homepage route
    },
    formattedAddress() {
      return this.header.Address
        ? this.header.Address.replace(/\n/g, "<br/>")
        : "";
    },
  },
  async mounted() {
    this.canShare = !!navigator.share;

    this.version = localStorage.getItem("dbVersion");
    try {
      // Fetch General Header data

      if (!this.tenantId) {
        throw new Error("Tenant ID not found in localStorage.");
      }

      var headerArray = await db.header
        .where("CustomerId")
        .equals(parseInt(this.tenantId))
        .toArray();

      if (headerArray.length > 0) {
        this.header = headerArray[0];
        console.log("Header:", this.header); // Log the header object

        // Log the specific value of BlogUrl
        console.log("header.BlogUrl:", this.header.BlogURL);

        // Log the value of isBlogUrlValid after header is set
        console.log("isBlogUrlValid:", this.isBlogUrlValid);
      } else {
        console.warn("No header data found for the given tenant ID.");
      }
    } catch (error) {
      console.error("Error fetching header data:", error);
    }

    // Add scroll listener on mount
    window.addEventListener("scroll", this.scrollFunction);
  },
  beforeDestroy() {
    // Remove scroll listener to prevent memory leaks
    window.removeEventListener("scroll", this.scrollFunction);
  },
  methods: {
    async sharePage() {
      if (navigator.share) {
        try {
          await navigator.share({
            title: document.title,
            text: "Check out Duhallow Walks",
            url: window.location.href,
          });
          console.log("Successfully shared!");
        } catch (error) {
          console.error("Error sharing:", error);
        }
      } else {
        alert("Sharing not supported on this browser.");
      }
    },
    async loadSocialLinks() {
      // Fetch the tenantId from local storage
      this.tenantId = localStorage.getItem("tenantId");

      try {
        // Fetch the first header record from IndexedDB
        const headerData = await db.header.toCollection().first();

        if (headerData) {
          // Populate socialLinks object
          this.socialLinks = {
            Facebook: headerData.Facebook,
            Instagram: headerData.Instagram,
            Youtube: headerData.Youtube,
            //Twitter: headerData.Twitter,
          };
        }

        // Wait for DOM updates to complete
        // /await nextTick();

        console.log("Social links rendered in DOM:", this.socialLinks);
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    },
    scrollFunction() {
      const mybutton = document.getElementById("btn-back-to-top");
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    },
    backToTop() {
      // Scroll to the top
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
    },
    deleteDatabase() {
      const dbName = "AppDatabase";

      const request = indexedDB.deleteDatabase(dbName);

      request.onsuccess = () => {
        console.log("Database deleted successfully");
        this.redirectHome();
      };

      request.onerror = event => {
        console.error("Error deleting database:", event);
      };

      request.onblocked = () => {
        console.warn("Database deletion blocked");
      };
    },
    redirectHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>
<style scoped>
.footer {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 0;
}

/* Full-width supporters bar spanning the bottom of the footer */
.supported-by-bar {
  width: 100%;
  margin-top: 30px;
}

/* Partner / supporter logos on a white panel (logos are transparent) */
.partner-logos {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 20px 40px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 22px 30px;
  margin-top: 12px;
  width: 100%;
}

.partner-logos img {
  height: 60px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

@media (max-width: 767px) {
  .partner-logos {
    gap: 18px 28px;
  }
  .partner-logos img {
    height: 44px;
  }
}

@media (max-width: 480px) {
  .partner-logos img {
    height: 38px;
  }
}
</style>
<style>
.homeFooter {
  padding-top: 20px;
}
</style>
